import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock } = FiIcons;

const Hero = () => {
  const currentDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  return (
    <section id="hero" className="relative pt-24 pb-20 px-6 hero-texture flex flex-col items-center text-center overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#F6F1E8] rounded-full blur-[100px] -z-10 opacity-50 pointer-events-none"></div>

      <div className="max-w-3xl mx-auto">
        <div className="inline-flex items-center space-x-2 bg-[#F6F1E8] border border-[#D9CCBA] px-4 py-1.5 rounded-full mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#6E7451] animate-pulse"></span>
          <span className="text-xs uppercase tracking-widest text-[#6E7451] font-medium">Internal Review Hub</span>
        </div>

        <h1 className="text-5xl md:text-6xl text-[#2F2B28] font-serif mb-6 leading-tight">
          Padua Strategy Dashboard
        </h1>
        
        <p className="text-xl md:text-2xl text-[#2F2B28]/80 font-light mb-6 font-serif italic">
          One place to review the ideas, planning, concepts, and direction we are building for Padua.
        </p>
        
        <p className="text-[#2F2B28]/60 max-w-xl mx-auto mb-10 leading-relaxed">
          Designed to keep the team aligned, organized, and moving forward with clarity.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-[#2F2B28]/50 border-t border-[#D9CCBA]/40 pt-8 mt-4">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiClock} className="w-4 h-4" />
            <span>Last Updated: {currentDate}</span>
          </div>
          <span className="hidden sm:inline text-[#D9CCBA]">•</span>
          <p className="max-w-md text-center sm:text-left">
            This dashboard is intended to keep current concepts and strategy pages organized in one place for easier review and discussion.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;